import { z } from 'zod';

export const makeBasicInfoSchema = (requireCode: boolean) =>
  z.object({
    name: z.string().trim().min(1, { message: 'Matter name must be provided' }),
    code: requireCode ? z.string().trim().min(1, { message: 'Matter code is required' }) : z.string().optional(),
    tokenLimit: z.number().optional(),
  });

export type BasicInfoForm = z.infer<ReturnType<typeof makeBasicInfoSchema>>;
